import { GenericApiResponse } from "src/@types/apis";
import { GetAsync, PostAsync, PutAsync } from "src/common/httpRequests";
import { PROCUREMENT_SERVICE_URL } from "src/constants/api";
import { API_GATEWAY } from "src/constants/settings";
import { handleResponse } from "src/helpers/helpers";
import {
  IPurchaseOrderDocument,
  IPurchaseOrderListParams,
  IPurchaseOrderListResponse,
} from "../types/purchaseOrderTypes";

const ENDPOINT = `${API_GATEWAY}${PROCUREMENT_SERVICE_URL}/PurchaseOrder`;

const getProcurementPurchaseOrderList = async (
  params: IPurchaseOrderListParams,
): Promise<GenericApiResponse<IPurchaseOrderListResponse>> => {
  const res = await GetAsync(`${ENDPOINT}/list`, true, undefined, { params });
  return handleResponse(res);
};

const createProcurementPurchaseOrder = async (
  payload: FormData,
): Promise<GenericApiResponse<undefined>> => {
  const res = await PostAsync(`${ENDPOINT}/create`, payload);
  return handleResponse(res);
};

const getProcurementPurchaseOrderById = async (
  documentId: string,
): Promise<GenericApiResponse<IPurchaseOrderDocument>> => {
  const res = await GetAsync(`${ENDPOINT}/useruploadedDocument/${documentId}`);
  return handleResponse(res);
};

const getProcurementDraftPurchaseOrderById = async (
  documentId: string,
): Promise<GenericApiResponse<IPurchaseOrderDocument>> => {
  const res = await GetAsync(`${ENDPOINT}/${documentId}`);
  return handleResponse(res);
};

const updateProcurementPurchaseOrder = async (payload: FormData) => {
  const res = await PutAsync(`${ENDPOINT}/update`, payload);
  return handleResponse(res);
};

const postPurchaseOrder = async (
  documentId: string,
): Promise<GenericApiResponse<undefined>> => {
  const res = await PostAsync(`${ENDPOINT}/post`, true, undefined, {
    params: { id: documentId },
  });
  return handleResponse(res);
};

export {
  createProcurementPurchaseOrder,
  getProcurementDraftPurchaseOrderById,
  getProcurementPurchaseOrderById,
  getProcurementPurchaseOrderList,
  postPurchaseOrder,
  updateProcurementPurchaseOrder,
};
